function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
const RadioBase = ({
  checked,
  palette
}) => /*#__PURE__*/React.createElement("svg", {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  fontSize: "24px"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "50%",
  cy: "50%",
  r: "11px",
  stroke: palette.primary.light,
  strokeWidth: "1px",
  fill: "none"
}), checked && /*#__PURE__*/React.createElement("circle", {
  cx: "50%",
  cy: "50%",
  r: "6px",
  fill: palette.primary.light
}));
RadioBase.propTypes = {
  checked: PropTypes.bool,
  palette: PropTypes.object
};
const useStyles = makeStyles(() => ({
  radioDisabled: {
    opacity: 0.8
  },
  radioButton: {
    padding: 0,
    paddingRight: "9px",
    "&&:hover": {
      backgroundColor: "transparent"
    }
  }
}));
const RadioButton = ({
  ...rest
}) => {
  const {
    palette
  } = useTheme();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(FormControlLabel, _extends({
    control: /*#__PURE__*/React.createElement(Radio, {
      disableRipple: true,
      classes: {
        disabled: classes.radioDisabled,
        root: classes.radioButton
      },
      checkedIcon: /*#__PURE__*/React.createElement(RadioBase, {
        checked: true,
        palette: palette
      }),
      icon: /*#__PURE__*/React.createElement(RadioBase, {
        palette: palette
      }),
      sx: {
        color: theme => theme.palette.primary.light,
        ...rest.radioButtonStyle
      }
    })
  }, rest));
};
export default RadioButton;